import React from 'react';
import { LookupSelect } from '../../../ActivitiesTypeView/ActivitiesTypeManagementView/DialogManagementViewComponent/DialogManagementConrtolComponent/LookupSelect';
import { BulkUpdateGeneralClientTrackingForSingle } from '../../../../../Services';
import { showError } from '../../../../../Helper';

const SourceOfLeadChanger = ({ sourceOfLeadId, onUpdate, ...rest }) => {
  const [value, setValue] = React.useState(sourceOfLeadId);
  const [loading, setLoading] = React.useState(false);
  const updateHandler = async (value) => {
    try {
      setLoading(true);
      const newItem = {
        ...rest,
        sourceOfLeadId: value,
      };
      await BulkUpdateGeneralClientTrackingForSingle(newItem);
      onUpdate(newItem);
      setValue(value);
    } catch (error) {
      setValue(sourceOfLeadId);
      showError('something went wrong, please try again');
    } finally {
      setLoading(false);
    }
  };
  return (
    <LookupSelect
      lookupName={'sourceOfLead'}
      value={value}
      onSelectChanged={updateHandler}
      className={'w-270px'}
      loading={loading}
      disabled={loading}
    />
  );
};
export default SourceOfLeadChanger;
